import type { Fees, Publisher } from 'api/publisher/types'

type PublisherDB = Publisher & Fees

export const publishers: PublisherDB[] = [
  {
    accountManagerId: '1',
    enabled: true,
    currency: 'EUR',
    isEligibleForTurbo: true,
    id: '1',
    name: 'Pub 1',
    createdAt: '2021-12-07T22:55:13Z',
    updatedAt: '2022-01-28T18:02:39Z',
    revenueShareMobile: 40,
    revenueBonusMobile: 1,
    revenueShareRiskBufferMobile: 2.5,
    revenueShareTransactionFeeMobile: 8.43,
    revenueFloorTurboApplications: [
      {
        name: 'Cross Puzzle',
        id: '1',
        revenueFloorTurboPlacements: [
          {
            name: 'Default',
            id: '1',
          },
          {
            name: "King's place",
            id: '2',
          },
        ],
      },
    ],
    revenueFeesHistory: [],
  },
  {
    accountManagerId: '2',
    enabled: true,
    id: '2',
    name: 'Pub 2',
    currency: 'USD',
    isEligibleForTurbo: true,
    createdAt: '2021-12-07T22:55:13Z',
    updatedAt: '2022-01-28T18:02:39Z',
    revenueShareMobile: 40,
    revenueBonusMobile: 1,
    revenueShareRiskBufferMobile: 2.5,
    revenueShareTransactionFeeMobile: 8.43,
    revenueFloorTurboApplications: [],
    revenueFeesHistory: [],
  },
  {
    accountManagerId: '3',
    enabled: true,
    id: '3',
    name: 'Pub 3',
    currency: 'EUR',
    isEligibleForTurbo: false,
    createdAt: '2021-12-07T22:55:13Z',
    updatedAt: '2022-01-28T18:02:39Z',
    revenueShareMobile: 40,
    revenueBonusMobile: 1,
    revenueShareRiskBufferMobile: 2.5,
    revenueShareTransactionFeeMobile: 8.43,
    revenueFloorTurboApplications: [],
    revenueFeesHistory: [],
  },
]
